var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_277_9997)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.62945 18.4C5.29555 18.4 4.01628 17.8768 3.07307 16.9456C2.12986 16.0144 1.59998 14.7514 1.59998 13.4345C1.59998 12.1175 2.12986 10.8545 3.07307 9.92333C4.01628 8.99212 5.29555 8.46897 6.62945 8.46897C6.94448 7.02033 7.8661 5.74729 9.19156 4.92989C9.84786 4.52516 10.5835 4.24447 11.3566 4.10385C12.1297 3.96323 12.925 3.96544 13.6972 4.11035C14.4693 4.25525 15.2032 4.54002 15.8569 4.94839C16.5106 5.35676 17.0712 5.88074 17.5069 6.4904C17.9426 7.10007 18.2448 7.78348 18.3962 8.50162C18.5475 9.21977 18.5452 9.95857 18.3892 10.6759H19.4582C20.4506 10.6759 21.4023 11.0828 22.104 11.807C22.8058 12.5313 23.2 13.5136 23.2 14.5379C23.2 15.5622 22.8058 16.5445 22.104 17.2688C21.4023 17.9931 20.4506 18.4 19.4582 18.4H18.3892",
    stroke: "#F9F9F9",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9 15L12 12L15 15",
    stroke: "#F9F9F9",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12 12.8008L12 20.8008",
    stroke: "#F9F9F9",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_277_9997"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUpload);
export default __webpack_public_path__ + "static/media/ic_upload.70df6ca140af02e09c039220cf04fdca.svg";
export { ForwardRef as ReactComponent };